import React, { useEffect, useState, useRef } from 'react';
import { describeFormErrors, ORDER_FIELD_LABELS } from '../../../lib/formErrors';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import * as yup from 'yup';
import dayjs from 'dayjs';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';

import * as fileApi from '../../../lib/api/file';
import * as projectApi from '../../../lib/api/project';
import * as approvalV2Api from '../../../lib/api/approvalV2';

import {
  initOrder,
  unloadOrderAdd,
} from '../../../modules/projectModule/orderAdd';
import { listOrderLetters } from '../../../modules/projectModule/orderLetters';

import OrderBookModal from '../../../components/chancemng/obtainorder/OrderBookModal';
import AskDialog from '../../../components/common/dialog/AskDialog';
import { chanceOrderCount } from '../../../modules/chanceModule/chance';

import { useChanceStore } from '../../../store/chanceStore'

const normalizeApprovalSteps = (steps, currentUserUuid) => {
  return (steps || [])
    .filter(Boolean)
    .map((value) => value.trim())
    .filter((value) => value && value !== currentUserUuid);
};

const validateApprovalSteps = (steps, currentUserUuid) => {
  const normalized = normalizeApprovalSteps(steps, currentUserUuid);

  if (normalized.length === 0) {
    return '최소 1명의 결재자를 추가하세요.';
  }
  if (normalized.some((value) => value === currentUserUuid)) {
    return '본인을 결재자로 지정할 수 없습니다.';
  }
  if (new Set(normalized).size !== normalized.length) {
    return '같은 결재자를 중복 지정할 수 없습니다.';
  }

  return '';
};

const getLineStepValues = (line, currentUserUuid) => {
  const normalized = normalizeApprovalSteps(
    line?.steps?.map((step) => step.assigneeUsrUuid) || [],
    currentUserUuid,
  );
  return normalized.length > 0 ? normalized : [''];
};

const OrderBookAddModalContainer = ({ type, open, handleClose }) => {
  const [isAuth, setIsAuth] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [lineId, setLineId] = useState('');
  const [approvalSteps, setApprovalSteps] = useState(['']);
  const [approvalLineList, setApprovalLineList] = useState([]);
  const [approvalLineLoading, setApprovalLineLoading] = useState(false);
  const [approvalStepsError, setApprovalStepsError] = useState('');
  const [finalApprovalAuth, setFinalApprovalAuth] = useState(null);
  const [finalApprovalYn, setFinalApprovalYn] = useState(false);
  const [finalApprovalComment, setFinalApprovalComment] = useState('');
  const scollToRef = useRef();

  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState(null);


  const onCancle = () => {
    setVisible(false);
  };

  const onConfirm = () => {
    setVisible(false);
  };

  const onClose = () => {
    formik.resetForm();
    setLineId('');
    setApprovalSteps(['']);
    setApprovalStepsError('');
    setFinalApprovalYn(false);
    setFinalApprovalComment('');
    handleClose();
  };

  const { user, chance, receiveOrderInf } = useSelector(
    ({ auth, chanceModule, projectModule, loading }) => ({
      chance: chanceModule.chance.chance,
      user: auth.user,
      receiveOrderInf: projectModule.orderAdd.receiveOrderInf,
      billInfList: projectModule.orderAdd.billInfList,
      billInvList: projectModule.orderAdd.billInvList,
      loading: loading['orderAdd/INIT_ORDER'],
    }),
  );

  useEffect(() => {
    if (!open) {
      return;
    }

    const fetchApprovalLines = async () => {
      setApprovalLineLoading(true);
      try {
        const res = await approvalV2Api.getApprovalV2Lines({ docType: 'ORDER_BOOK' });
        setApprovalLineList(res.data.list || []);
      } catch (e) {
        enqueueSnackbar('v2 결재선 템플릿 조회 실패', { variant: 'error' });
      } finally {
        setApprovalLineLoading(false);
      }
    };

    fetchApprovalLines();
  }, [enqueueSnackbar, open]);

  useEffect(() => {
    if (!open) {
      return;
    }

    const fetchFinalApprovalAuth = async () => {
      try {
        const res = await approvalV2Api.getMyFinalApprovalAuth({
          docType: 'ORDER_BOOK',
          amount: chance?.totalSales,
        });
        const auth = res.data?.canApprove ? res.data.info : null;
        setFinalApprovalAuth(auth);
        if (!auth) {
          setFinalApprovalYn(false);
        }
      } catch (e) {
        setFinalApprovalAuth(null);
        setFinalApprovalYn(false);
      }
    };

    fetchFinalApprovalAuth();
  }, [open, chance?.totalSales]);

  useEffect(() => {
    //최초 등록시 초기 데이터 생성함.

//    alert(dayjs().format('YYYY-MM-DD'));

    if (chance) {
      dispatch(initOrder(chance));
      formik.setFieldValue('siDt', chance.expDay);
      formik.setFieldValue('comment', chance.forcastTxt);
      formik.setFieldValue('roProfitAmt', chance.totalProfit);
      formik.setFieldValue('roAdjProfitAmt', chance.totalProfit);
//      alert('last : ' + dayjs().add(12, 'month').endOf('month').format('YYYY-MM-DD'));
      formik.setFieldValue('licStrtDt', dayjs().format('YYYY-MM-DD'));
      formik.setFieldValue('licEndDt', dayjs().add(12, 'month').endOf('month').format('YYYY-MM-DD'));

      formik.setFieldValue(
        'roProfitAmtPercent',
        getPercentByTotal(chance.totalProfit),
      );
      formik.setFieldValue(
        'roAdjProfitAmtPercent',
        getPercentByTotal(chance.totalProfit),
      );
    }

    //언마운트될때 리덕스에서 파트너 데이터 초기화
    return () => {
      dispatch(unloadOrderAdd());
    };
  }, [open]);

  const getPercentByTotal = (newValue) => {
    const totalSales = chance?.totalSales; //매출액
    const numberValue = Number(newValue);
    const percent = Math.round((numberValue / totalSales) * 100);
    return percent;
  };

  useEffect(() => {
    const findIndex = _.findIndex(
      user?.privilegeList,
      (auth) => auth?.authTyp === 'MINUS_PO' && auth?.authYn === 'Y',
    );
    // console.log(findIndex, 'findIndex');
    if (findIndex !== -1) {
      setIsAuth(true);
    }
  }, [user]);

//  const date = dayjs().add(12, 'month').endOf('month');

  const [initialValues, setInitialValues] = useState({
    mtnFreeTm: '',
    expDay: new Date(),
    siDt: '',
    mtnFreeStrtDt: '',
    mtnFreeEndDt: '',
    inspectCond: '',
    dlvryDuedate: '',
    licStrtDt: '',
    licEndDt: '',
    collCondt: '세금계산서 발행후 익월말',
    payCondt: '현금',
    comment: '',
    roProfitAmt: '', //매출이익
    roProfitAmtPercent: '', //매출액 대비 매출이익 퍼센트
    roCostAmt: 0, //영업비용
    roCostAmtPercent: 0, //매출액 대비 영업비용 퍼센트
    roAdjProfitAmt: 0, //최종 매출이익
    roAdjProfitAmtPercent: 0, //매출액 대비 최종 매출이익

    roInternalCosts: [
      {
        roPartnerUsrNm: '',
        roPartnerUsr: '',
        roInternalAmt: 0,
        roInternalAmtPercent: 0,
      },
    ],
    files: [{ fileDesc: '', file: null }],

    /** @todo : 세금계산서 내역 추가 필요  */
  });

  const billInfListData = useChanceStore(state => state.billInfList)
  const billInvListData = useChanceStore(state => state.billInvList)

    
  // const billInfListFromRedux = useSelector(state => state.projectModule.billInfList);
  // const billInvListFromRedux = useSelector(state => state.projectModule.billInvList);
   
  const validationSchema = yup.object({
    expDay: yup
      .date('계약일을 입력하세요')
      .required('계약일을 입력하세요')
      .nullable()
      .default(undefined),
    siDt: yup
      .date('계약완료일을 입력하세요')
      .required('계약완료일을 입력하세요')
      .nullable()
      .default(undefined),
    // 화면에는 필수(*)로 표시되는데 규칙이 없어서 비워도 그냥 저장됐다.
    // 이 값이 비면 DLVRY_DUE_DT 가 NULL 이 되고 납기 OTD 가 수주 납기를 못 본다.
    dlvryDuedate: yup
      .date('납품 예정일을 입력하세요')
      .required('납품 예정일을 입력하세요')
      .nullable()
      .default(undefined),
    mtnFreeStrtDt: yup
      .date()
      .test(
        'project-mtnFreeStrtDt',
        '무상 유지보수 시작일을 입력하세요',
        function (value) {
          let result = chance?.prjTyp === 'N' && value === null ? false : true;
          return result;
        },
      )
      .nullable()
      .default(undefined),
    mtnFreeEndDt: yup
      .date()
      .test(
        'project-mtnFreeEndDt',
        '무상 유지보수 종료일을 입력하세요',
        function (value) {
          let result = chance?.prjTyp === 'N' && value === null ? false : true;
          return result;
        },
      )
      .nullable()
      // min(ref) 는 비교 대상이 비어 있어도 실패한다. 시작일을 안 넣고 종료일만 고르면
      // 걸리는데, 이 칸들은 유지보수 프로젝트가 아니면 화면에 아예 없다.
      // 그래서 보이지도 않는 칸 때문에 저장이 막혔다. 둘 다 있을 때만 비교한다.
      .test('mtnFreeEndDt-after-start', '무상유지보수 종료일을 확인하세요', function (value) {
        const start = this.parent?.mtnFreeStrtDt;
        if (!value || !start) return true;
        return new Date(value) >= new Date(start);
      })
      .default(undefined),
    collCondt: yup.string().nullable(),
    payCondt: yup.string().nullable(),
    comment: yup.string().nullable(),

    roProfitAmt: yup
      .number()
      .test('roProfitAmt-min', '최소 0이상 입력하세요', function (value) {
        const result = !isAuth && value < 0 ? false : true;
        return result;
      }),
    roCostAmt: yup
      .number()
      .test('roCostAmt-min', '최소 0이상 입력하세요', function (value) {
        const result = !isAuth && value < 0 ? false : true;
        return result;
      }),

    // 사용자 권한(MINUS_PO)이 있다면 min 적용 안함. 권한 없으면 min 적용

    roInternalCosts: yup.array().of(
      yup.object().shape({
        roPartnerUsrNm: yup
          .string('')
          .when('roInternalAmt', (roInternalAmt, schema) => {
            if (roInternalAmt)
              return schema.required('협업담당자를 입력하세요');
          }),
        roInternalAmt: yup
          .number()
          .test('roInternalAmt-min', '최소 0이상 입력하세요', function (value) {
            const result = !isAuth && value < 0 ? false : true;
            return result;
          }),
      }),
    ),
  });

      
  // const { billInvList,billInfList } = useSelector(({ projectModule }) => ({
  //   billInvList: projectModule.orderAdd.billInvList,
  //   billInfList: projectModule.orderAdd.billInfList,
  // }));

      
  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    // validateOnChange: false,
    // validateOnBlur: false,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);

      const stepError = finalApprovalYn ? '' : validateApprovalSteps(approvalSteps, user?.usrUuid);
      if (stepError) {
        setApprovalStepsError(stepError);
        setMessage(stepError);
        setVisible(true);
        setSubmitting(false);
        return;
      }


      // // const billInfListFromRedux = useSelector(state => state.projectModule.orderAdd.billInfList);
      // // const billInvListFromRedux = useSelector(state => state.projectModule.orderAdd.billInvList);
      // console.log(billInfListData);
      
      const zeroInstallmentList = billInfListData.filter(item => item.installment ==  0);

      // console.log(zeroInstallmentList);
      // console.log(zeroInstallmentList.length );
      // console.log( " hasZeroInstallment : " + zeroInstallmentList );
      // const billInvListData = useChanceStore(state => state.billInfList)

      // if( (zeroInstallmentList != null && zeroInstallmentList.length > 0) || billInfListData.length == 0) {
//      if( billInvListData.length == 0 ) { 
      if( zeroInstallmentList.length > 0 ) {
        setMessage('세금계산서 발행사항이 없습니다');
        setVisible(true);
        setSubmitting(false);
        return;
      }
      // alert('ok');
      onAddOrder(formik.values);

      onClose();
      setSubmitting(false);
      
    },
  });

  /**
   * 저장이 조용히 막히는 것을 없앤다.
   *
   * 검증에 걸리면 formik 은 저장을 하지 않고 아무 일도 하지 않는다. 메시지는 항목 아래에
   * 뜨지만, 그 항목이 화면에 없으면(유지보수 프로젝트가 아닐 때 감춰지는 날짜 칸 등)
   * 화면에는 아무 변화가 없다. 사용자에게는 저장 버튼이 죽은 것으로 보인다.
   * 걸린 항목을 모아 한 번에 알려준다.
   */
  useEffect(() => {
    if (!formik.submitCount || formik.isValidating || formik.isValid) return;
    const text = describeFormErrors(formik.errors, ORDER_FIELD_LABELS);
    if (text) {
      setMessage(text);
      setVisible(true);
    }
  }, [formik.submitCount, formik.isValidating]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleApprovalLineChange = (nextLineId) => {
    const selectedLine = approvalLineList.find((line) => line.lineId === nextLineId);
    if (!selectedLine) {
      setLineId('');
      setApprovalSteps(['']);
      return;
    }

    setLineId(nextLineId);
    setApprovalSteps(getLineStepValues(selectedLine, user?.usrUuid));
    setApprovalStepsError('');
  };

  const handleApprovalStepsChange = (steps) => {
    setApprovalSteps(steps);
    if (lineId) {
      setLineId('');
    }
    if (approvalStepsError) {
      setApprovalStepsError('');
    }
  };

  //valid 가 맞지 않을 때 스크롤.
  useEffect(() => {
    if (!formik?.isValid) {
      scollToRef.current?.scrollIntoView();
    }
  }, [formik?.isValid]);

  const onFileSave = async (value, orderInfo) => {
    let formData = new FormData();
    formData.append('fileDt', value.file);
    formData.append('fileTyp', 'PROJECT_PO');
    formData.append('fileAttrVal1', orderInfo.prjUuid);
    formData.append('fileAttrVal2', '수주품의서');
    formData.append('fileAttrVal3', orderInfo.roUuid);
    formData.append('fileDesc', value.fileDesc);
    //console.log(formData, 'formData');

    try {
      const response = await fileApi.addFiles(formData);

      if (response.data.result === 'success') {
        enqueueSnackbar('수주품의서 파일 업로드 성공', {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

//  const onRowsChange(billInf) => {

//     // onchange시에 
//     setBillInfList(billInf);
//  };

  const onAddOrder = async (values) => {
    const orderLetterInfo = getReceiveOrderInf(formik.values);
    let dataToSubmit = {
      receiveOrderInf: orderLetterInfo,
      billInfList: billInfListData,
      billInvList: billInvListData,
      lineId: finalApprovalYn ? undefined : lineId || undefined,
      approverUuids: finalApprovalYn ? [] : normalizeApprovalSteps(approvalSteps, user?.usrUuid),
      finalApprovalYn: finalApprovalYn ? 'Y' : 'N',
      finalApprovalComment: finalApprovalYn ? finalApprovalComment : undefined,
    };

    try {
      const res = await projectApi.addReceiveOrder(dataToSubmit);

      if (res.data) {
        //실제 업로드 파일이 있다면
        if (values.files.length > 0 && values.files[0].file !== null) {
          values.files.forEach((value) => {
            onFileSave(value, res.data.receiveOrderInf);
          });
        }

        dispatch(listOrderLetters(chance.prjUuid));
        dispatch(chanceOrderCount(chance.prjUuid));

        enqueueSnackbar(`수주품의서 저장 성공`, {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        err.response !== 'undefined' ? err.response.data?.message : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  function getReceiveOrderInf(values) {
    // const dateDif = dayjs(values.mtnFreeEndDt) - dayjs(values.mtnFreeStrtDt);
    // const cDay = 24 * 60 * 60 * 1000;
    // const cMonth = cDay * 30; // 월 만듬
    // const difMonth = Math.ceil(dateDif / cMonth);

   

    let ReceiveOrderInf = {
      roUuid: receiveOrderInf.roUuid,
      prjUuid: receiveOrderInf.prjUuid,
      partnerUuid: receiveOrderInf.partnerUuid,
      employeeUuid: receiveOrderInf.employeeUuid,
      partnerInc: receiveOrderInf.partnerInc,
      chargeNm: receiveOrderInf.chargeNm,
      salesUuid: receiveOrderInf.salesUuid,
      collCondt: values.collCondt,
      payCondt: values.payCondt,
      comment: values.comment,
      // mtnFreeTm: difMonth,=> api 에서 계산
      expDay: values.expDay ? dayjs(values.expDay).format('YYYY-MM-DD') : null,
      siDt: values.siDt ? dayjs(values.siDt).format('YYYY-MM-DD') : null,
      mtnFreeStrtDt: values.mtnFreeStrtDt
        ? dayjs(values.mtnFreeStrtDt).format('YYYY-MM-DD')
        : null,
      mtnFreeEndDt: values.mtnFreeEndDt
        ? dayjs(values.mtnFreeEndDt).format('YYYY-MM-DD')
        : null,

        inspectCond: values.inspectCond,
        dlvryDuedate: values.dlvryDuedate
        ? dayjs(values.dlvryDuedate).format('YYYY-MM-DD')
        : null,

      licStrtDt: values.licStrtDt
        ? dayjs(values.licStrtDt).format('YYYY-MM-DD')
        : null,
      licEndDt: values.licEndDt
        ? dayjs(values.licEndDt).format('YYYY-MM-DD')
        : null,

      giPrePct: values.giPrePct, //보증보험(선급금 비율율)
      giCovPct: values.giCovPct, //보증보험(계약이행 비율)
      giMtnPct: values.giMtnPct, //보증보험(하자유지보수 비율)


      roProfitAmt: values.roProfitAmt, //매출이익
      roProfitAmtPercent: values.roProfitAmtPercent, //매출이익 퍼센트
      roCostAmt: values.roCostAmt,
      roCostAmtPercent: values.roCostAmtPercent,
      roAdjProfitAmt: values.roAdjProfitAmt,
      roAdjProfitAmtPercent: values.roAdjProfitAmtPercent,
      roTotalAmt: chance.totalSales, //총 매출액

      roInternalCosts: values.roInternalCosts, //내부거래비용array
    };
    return ReceiveOrderInf;
  }

  return (
    <>
      <OrderBookModal
        chance={chance}
        type={type}
        open={open}
        handleClose={onClose}
        orderInfo={receiveOrderInf}
        formik={formik}
        user={user}
        lineId={lineId}
        approvalSteps={approvalSteps}
        approvalLines={approvalLineList}
        approvalLineLoading={approvalLineLoading}
        currentUserUuid={user?.usrUuid}
        approvalStepsError={approvalStepsError}
        finalApprovalAvailable={Boolean(finalApprovalAuth)}
        finalApprovalYn={finalApprovalYn}
        finalApprovalComment={finalApprovalComment}
        setFinalApprovalYn={setFinalApprovalYn}
        setFinalApprovalComment={setFinalApprovalComment}
        setLineId={handleApprovalLineChange}
        setApprovalSteps={handleApprovalStepsChange}
        scollToRef={scollToRef}      
        />
      <AskDialog
        visible={visible}
        title="확인"
        description={message}
        confirmText="확인"
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
    </>
  );
};

export default OrderBookAddModalContainer;
